<template>
    <simple-dropdown :dropdown-arrow="true" :alignment="1" :dropdown-wrapper-style="{padding: '0'}"
                     :click-dropdown-menu-to-hide="false" ref="simpleDropdown">
        <template v-slot:triggerButtonContent>
            <button class="pure button-settings"><i class="gf gf-settings"></i></button>
        </template>
        <template v-slot:dropdownMenu>
            <div class="dropdown-content">
                <div class="settings-contents">
                    <!--                    <header class="header">-->
                    <!--                        <span>Settings</span>-->
                    <!--                    </header>-->
                    <main class="body">
                        <div class="property">
                            <div class="property-header">
                                <span>Work Mode:</span>
                            </div>
                            <div class="property-body">
                                <div class="options">
                                    <button v-for="(item,index) in workModeOptions"
                                            @click="onWorkModeSelectChange(item.value)"
                                            :key="index" :class="{active: item.value===workMode}">{{item.label}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </template>
    </simple-dropdown>
</template>

<script>
    import SimpleDropdown from "@/components/SimpleDropdown";
    import {userSettingsManager, workModeEdit, workModeRead} from "@/utils";

    const workModeOptions = [
        {
            value: workModeEdit,
            label: 'Edit',
        },
        {
            value: workModeRead,
            label: 'Read'
        }
    ];

    export default {
        name: "SettingsButton",
        components: {SimpleDropdown},
        data() {
            return {
                workModeOptions: workModeOptions,
            }
        },
        methods: {
            onWorkModeSelectChange(newVal) {
                if (newVal === this.workMode) {
                    return;
                }
                if (newVal === workModeRead && this.$store.state.existsUnsavedChanges) {
                    alert('You cannot switch to Read Mode while having unsaved changes!');
                    return;
                }

                userSettingsManager.setWorkMode(newVal);
            }
        },
        computed: {
            workMode() {
                return userSettingsManager.getWorkMode();
            },
        },
    }
</script>

<style scoped lang="scss">
    .button-settings.pure {
        font-size: 1.5rem;
        box-shadow: none;
    }
</style>
<style lang="scss">
    @import "../assets/variables";

    .settings-contents {

        .header {
            text-align: center;
            font-weight: 500;
            padding: 0.25rem;
        }

        .body {
            padding: 0.8rem 0.95rem 0.8rem;
        }

        label {
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                margin-right: 0.25rem;
            }

            select {
                font-size: 1em;
            }
        }

        .property-header {
            margin-bottom: 0.5rem;
        }

        .property-body {
            button {
                border-radius: 2px;
                background-color: transparent;
                min-width: 52px;

                &:not(:last-child) {
                    margin-right: 0.5rem;
                }

                &:focus {
                    box-shadow: none;
                }

                &:not(.active):active {
                    background-color: #f0f0f0;
                }

                &.active {
                    border: 1px solid $primary-blue;
                    color: $primary-blue;
                    background-color: rgba($primary-blue, 0.1);
                    cursor: default;
                }
            }
        }
    }
</style>
